import React from "react";

export default function Linkedin({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.725"
      height="40.627"
      viewBox="0 0 39.725 40.627"
      className={className}
    >
      <path
        id="Path_300"
        data-name="Path 300"
        d="M1091.862,8218a20.058,20.058,0,0,1,19.863,20.169c.009,11.357-8.821,20.458-19.854,20.458a20.318,20.318,0,0,1-.009-40.627Zm1.751,17.785c.009-1.19-.587-1.426-1.444-1.3a5.155,5.155,0,0,1-.65,0,1.533,1.533,0,0,0-1.743,1.716v10.96h1.607c2.6-.027,2.248.271,2.275-2.248.009-1.345-.018-2.681.009-4.027a7.2,7.2,0,0,1,.19-1.579,1.953,1.953,0,0,1,2.257-1.58,1.761,1.761,0,0,1,1.688,1.888c.081,2.139.036,4.279.1,6.428.009.36.271,1.011.469,1.038a14.535,14.535,0,0,0,2.871.019c.19-.019.515-.479.515-.74a79.2,79.2,0,0,0-.153-8.288,4.339,4.339,0,0,0-7.033-3.034c-.253.181-.478.38-.957.749Zm-6.193,5.237c0-1.291.018-2.591,0-3.883-.054-3.061.478-2.563-2.654-2.672-1.111-.045-1.3.424-1.282,1.407.045,2.854-.009,5.707.018,8.561.045,3.123-.551,2.645,2.708,2.744,1.029.026,1.264-.4,1.228-1.346-.063-1.6-.018-3.2-.018-4.812Zm-1.9-12.767a2.273,2.273,0,0,0-2.311,2.222,2.3,2.3,0,0,0,2.2,2.347,2.285,2.285,0,0,0,.108-4.568Z"
        transform="translate(-1072 -8218)"
        fill="currentColor"
      />
    </svg>
  );
}
